import React from 'react';

import Dialog from '@crehana/ui/dist/Dialog';
import { PrimaryButton } from '@crehana/ui/dist/Buttons';
import { customLocalStorage } from '@crehana/utils';

import PhoneInput, { usePhoneNumberState } from 'Shared/PhoneInput';

import getCountryPrefix from 'Jsx/Utils/getCountryPrefix';
import getStaticUrl from 'Jsx/Utils/getStaticUrl';

import useContactData from 'Jsx/Auth/hooks/useContactData';

const FailedPaymentPopup: React.FC<{
  email: string;
  open: boolean;
}> = ({ email, open }) => {
  const { saveContactData } = useContactData();
  const { phoneState, setPhoneState } = usePhoneNumberState();
  const [openDialog, setOpenDialog] = React.useState<boolean>(open);
  const [showThanks, setShowThanks] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  const isSaveButtonActive = email && phoneState.isValid;

  React.useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const onSaveContact = () => {
    saveContactData({
      name: '-',
      email,
      phoneNumber: `${phoneState.code} ${phoneState.phoneNumber}`,
      source: 'SOURCE_CHECKOUT',
    })
      .then(success => {
        if (success) {
          setShowThanks(success);
        } else {
          setErrorMessage(
            'Hubo un error al enviar tus datos, por favor intenta de nuevo.',
          );
        }
      })
      .catch(() => setErrorMessage(''));
  };
  const onDismiss = () => {
    setOpenDialog(false);
    customLocalStorage.setItem('failedPayment', 'saved');
  };

  return (
    <Dialog open={openDialog} size="s" onDismiss={onDismiss} hideCloseBtn>
      <form
        className="py-80 sm:py-48 md:pt-48 md:pb-80 px-16 w-full mx-auto"
        style={{ maxWidth: 560 }}
      >
        <p className="text-center mb-24">
          <img
            alt="phone"
            src={getStaticUrl('img/checkout/failed-payment.jpg')}
            width="98px"
            height="88px"
          />
        </p>
        {showThanks ? (
          <div>
            <h4 className="font-h3 mb-8 text-center">
              ¡Tu asesor está en camino!
            </h4>
            <p className="font-body3 mb-24 text-center">
              Hemos recibido tus datos y en breves momentos estaremos contigo.
            </p>
            <p className="text-center">
              <PrimaryButton label="Confirmar" onClick={onDismiss} />
            </p>
          </div>
        ) : (
          <div>
            <h4 className="font-h3 mb-8 text-center">
              Hubo un problema con tu pago
            </h4>
            <p className="font-body3 mb-24 text-centers">
              Podemos ayudarte a solucionarlo ¿Deseas comunicarte con un asesor?
            </p>

            <PhoneInput
              className="mb-24 text-base-main"
              defaultCountry={getCountryPrefix()}
              showAll
              onChange={setPhoneState}
              check={phoneState.isValid}
              label="Número de celular"
            />
            <p className="text-center">
              <PrimaryButton
                label="Comunícame con un asesor"
                size="l"
                full
                className="max-w-320 mb-24"
                onClick={onSaveContact}
                disabled={!isSaveButtonActive}
              />
            </p>
            <p className="text-center">
              <button
                type="button"
                className="font-button text-secondary-main"
                onClick={onDismiss}
              >
                Volveré a intentarlo
              </button>
            </p>
            {errorMessage && (
              <p className="text-center font-caption mt-8 text-red-main">
                {errorMessage}
              </p>
            )}
          </div>
        )}
      </form>
    </Dialog>
  );
};

export default FailedPaymentPopup;
